import { useSortable } from "@dnd-kit/sortable";

import { CSS } from '@dnd-kit/utilities';
import ReordonnerProposition from "./ReordonnerProposition";

const ReordonnerDraggable = ({proposition, hovered}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({id: proposition.ID});



  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (

      <ReordonnerProposition proposition={proposition} ref={setNodeRef}
    style={style}
    {...attributes}
    {...listeners}
    hovered={hovered} />

  )
}


export default ReordonnerDraggable